<template>
    <div class="involved-projects">

        <div class="involved" v-loading="loading">

            <div
                class="empty"
                v-if="!items.length"
            >Вы еще не подавали заявку на проектную инициативу</div>

            <MineProposalItem
                v-for="item in items"
                :key="item.id"
                :item="item"
            />
        </div>

    </div>
</template>

<script>
import MineProposalItem from './MineProposalItem';

export default {
    name: 'MineProposals',
    props: {
        loading: Boolean,
        items: Array,
    },
    data: () => ({
    }),
    methods: {
    },
    components: {
        MineProposalItem,
    },
    created() {
        this.$store.dispatch('loadDictionaryItems', 'projects_thematic_directions');
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../../styles/variables";
    @import '../../../../styles/rem';
    @import '../../../../styles/mrem';

    .empty {
        margin-bottom: rem(32);
        font-weight: 600;
        font-size: rem(15);
        line-height: rem(22);
        color: #98A0A9;

        @include on-mobile {
            margin-bottom: mrem(32);
            font-size: mrem(15);
            line-height: mrem(22);
        }
    }
</style>
